import React from 'react';
import Bullets from 'slickpay/common/Bullets.component';

import CN from './UiPage.module.scss';

const BULLET_ITEMS = ['Login to your Slick account', 'Go to Settings', 'Navigate to Preferences', 'Enable Notifications'];

const BulletsPanel = () => (
  <div data-bem="BulletsPanel" className={CN.container}>
    <div className={CN.verticalFlex} style={{ gap: 16 }}>
      <div className={CN.title}>Default</div>
      <Bullets tag="BulletsPanel" data={BULLET_ITEMS} />

      <div className={CN.title}>variantInvert + checkmarkWhite</div>
      <div style={{ background: '#2a064b', padding: 16, borderRadius: 8 }}>
        <Bullets tag="BulletsPanel" data={BULLET_ITEMS} variantInvert checkmarkWhite />
      </div>

      <div className={CN.title}>hardware</div>
      <Bullets tag="BulletsPanel" data={BULLET_ITEMS} hardware />

      <div className={CN.title}>empty</div>
      <Bullets tag="BulletsPanel" data={BULLET_ITEMS} empty />

      <div className={CN.title}>empty + compact</div>
      <Bullets tag="BulletsPanel" data={BULLET_ITEMS} empty compact />

      <div className={CN.title}>dot</div>
      <Bullets tag="BulletsPanel" data={BULLET_ITEMS} dot />

      <div className={CN.title}>dot + variantInvert</div>
      <div style={{ background: '#2a064b', padding: 16, borderRadius: 8 }}>
        <Bullets tag="BulletsPanel" data={BULLET_ITEMS} dot variantInvert />
      </div>

      <div className={CN.title}>star</div>
      <Bullets tag="BulletsPanel" data={BULLET_ITEMS} star />
    </div>
  </div>
);

export default BulletsPanel;
